import axios from "axios";
import { store } from "../../../redux/store";
// import Provider from '../../singleton';
import { getEcommAuthToken } from "~/app/modules/authentication/services";

// const providerInstance = Provider.getInstance();

/*global ECOMM_API */
/*eslint no-undef: "error"*/
const ECOMM = axios.create({
  baseURL: ECOMM_API,
  timeout: 16000,
  withCredentials: true,
});

const getAuthToken = () => {
  return store.getState().authentication?.ecomm_auth?.response?.access_token;
};

const handleRequest = async (req) => {
  if (getAuthToken()) req.headers["Authorization"] = `Bearer ${getAuthToken()}`;
  return req;
};

function refreshEcommToken(config) {
  // const schema = providerInstance.getSchema();
  // store.dispatch(getEcommAuthToken(schema)).then(() => {
  store.dispatch(getEcommAuthToken("public")).then(() => {
    if (!store.getState().authentication?.ecomm_auth?.hasError) {
      ECOMM.request(config);
    }
  });
}

const handleError = (error) => {
  /*eslint no-undef: "error"*/
  let parsed_error = Object.assign({}, error);
  if (parsed_error?.response?.status == 401) {
    refreshEcommToken(parsed_error?.config);
  }
  return Promise.reject(parsed_error?.response?.data);
};

const handleResponse = (response) => {
  return Promise.resolve(response.data);
};

ECOMM.interceptors.request.use(handleRequest);
ECOMM.interceptors.response.use(handleResponse, handleError);

export default ECOMM;
